import Automation from '../placement-automation/Automation.vue';
import SettingsWrapper from '../settings/SettingsWrapper.vue';
import Index from './Index.vue';
export const routes = [
  {
    path: 'placements',
    component: SettingsWrapper,
    props: { keepAlive: false },
    meta: { permissions: ['administrator'] },
    children: [
      {
        path: 'automation',
        name: 'telegram_placement_automation',
        component: Automation,
        meta: { permissions: ['administrator'] },
      },
      {
        path: '',
        name: 'telegram_placements',
        component: Index,
        meta: { permissions: ['administrator'] },
      },
    ],
  },
];
